import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getMessageById } from '@/services/utilService';

const initialState = {
  message: {},
  loading: false,
};

export const fetchMessageById = createAsyncThunk(
  'messageTrace/fetchMessageById',
  async (params) => {
    const response = await getMessageById(params);
    return {
      ...params,
      ...response.data,
    };
  },
);

export const messageTraceSlice = createSlice({
  name: 'messageTrace',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessageById.pending, (state) => {
        state.message = {};
        state.loading = true;
      })
      .addCase(fetchMessageById.fulfilled, (state, action) => {
        state.message = action.payload;
        state.loading = false;
      })
      .addCase(fetchMessageById.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default messageTraceSlice.reducer;

export const { reset } = messageTraceSlice.actions;
